export const environment = {
  production: false,
  backend: 'https://backend-staging.uz-ip.tech/uzai',
  thresholds: {
    imports: {
      excelRows: 100 // limit excel rows for TMs/URLs/etc. import
    }
  }
};
